// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"cp_hP","policy":"cp_b2","buttonContainer":"cp_d4","successMessage":"cp_hQ","underline":"cp_b3"};